import { Reducer } from 'redux';
import deepmerge from 'deepmerge';
import { DocActionTypes, IFollowUpDocumentsState } from './types';
import { StudentActionTypes } from '../types';
import { DataActionTypes } from '../../data/types';
import { UIActionTypes } from '../../ui/types';
import { transformObject } from '../documents/helpers';
import { IAnyObj } from '../../../types';
import { getDocDetails } from '../../../utilities/documents';

const initialState: IFollowUpDocumentsState = {
  beforeTravel: {
    studentRefusalLetter: {},
    customRequest: {},
    immigrationStatusPdfCopy: {},
    immigrationStatusShareCode: {},
    visaApplicationPdfCopy: {},
    visaVignette: {},
    travelTicket: {},
  },
  afterArrival: {
    customRequest: {},
    biometricResidencePermit: {},
    stampedVisaVignette: {},
  },
};

const overwriteMerge = (_: [], sourceArray: []) => sourceArray;

const mainReducer: Reducer<IFollowUpDocumentsState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_FOLLOW_UP_DOCS_SUCCESS: {
      const followUpDocs = transformObject(action.payload.followUpDocs);
      return {
        ...initialState,
        ...followUpDocs,
      };
    }
    case StudentActionTypes.UPDATE_VISA_STATUS_SUCCESS:
    case StudentActionTypes.UPDATE_STATUS_SUCCESS:
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS: {
      if (action.payload.followUpDocuments) {
        return {
          ...state,
          ...action.payload.followUpDocuments,
        };
      }
      return state;
    }
    case StudentActionTypes.UPDATE_FOLLOW_UP_DOCUMENTS: {
      if (action.payload.followUpDocs) {
        const newState = deepmerge(state, action.payload.followUpDocs, {
          arrayMerge: overwriteMerge,
        });
        return {
          ...newState,
        };
      }
      return state;
    }

    case StudentActionTypes.DELETE_FILE: {
      const { sponsorKey, docType, docKey, fileNames, isFollowUpDocumentModal } = action.payload;

      const { sponsorType } = action.payload;

      if (!isFollowUpDocumentModal) {
        return state;
      }

      const newState = { ...state };
      const newRecord = getDocDetails({ docs: newState, sponsorType, sponsorKey, docType, docKey }) as IAnyObj;
      newRecord.fileNames = fileNames;

      return {
        ...newState,
      };
    }

    case DataActionTypes.UPLOAD_FILE_SUCCESS: {
      const { sponsorKey, docType, docKey, fileNames, isFollowUpDocumentModal } = action.payload;

      const { sponsorType } = action.payload;

      if (!isFollowUpDocumentModal) {
        return state;
      }

      const status = 'UPLOADED_OK';
      const newState = { ...state };
      const newRecord = getDocDetails({ docs: newState, sponsorType, sponsorKey, docType, docKey }) as IAnyObj;

      // strip out file upload failures
      let parsedFileNames: string[] = fileNames;
      parsedFileNames = fileNames?.filter((fName: string) => !fName.includes('upload--error--')) ?? [];
      newRecord.fileNames = parsedFileNames;

      newRecord.status = status;

      return {
        ...newState,
      };
    }

    case UIActionTypes.OPEN_FOLLOW_UP_UPLOAD_MODAL: {
      const { sponsorKey, docType, docKey, metadata } = action.payload;

      const { sponsorType } = action.payload;

      const newState = { ...state };
      const newRecord = getDocDetails({ docs: newState, sponsorType, sponsorKey, docType, docKey }) as IAnyObj;

      Object.entries(metadata ?? {}).forEach(([key, value]) => {
        if (value !== undefined) {
          newRecord[key] = value;
        }
      });
      return {
        ...newState,
      };
    }
    case StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS_SUCCESS:
    case DocActionTypes.TOGGLE_DOC_SUCCESS: {
      const docs = transformObject(action.payload.followUpDocs);
      // merge the delta
      const newState = deepmerge(state, docs, {
        arrayMerge: overwriteMerge,
      });
      return {
        ...newState,
      };
    }

    default:
      return state;
  }
};

export { mainReducer as followUpDocumentsReducers };
